import { pluralizeHours, pluralizeWeeks } from '@/tools/pluralize';
import { Events, Event, ParsedEvent, ParsedEvents } from './types';

const parse = (item: Event): Readonly<ParsedEvent> =>
  Object.freeze({
    id: item!.id || '',
    title: item!.name || '',
    code: item!.url_code || '',
    note: item!.announce || '',
    img: (item.image && item.image.little) || '',
    image: {
      small: (item.image && item.image.little) || '',
      large: (item.image && item.image.big) || '',
    },
    labor_program: pluralizeHours(item!.labor_program || ''),
    length: item!.length_text || '',
    is_open: item.is_open,
    is_free: item!.is_free,
    form_education_id: item!.form_education_id || '',
    cost: parseCost(item!.cost),
    badge: item.is_ovz ? ['ovz'] : [],
    age_from: item!.age_from || '',
    age_to: item!.age_to || '',
  });

const parseCost = (val: string | number | null) =>
  val ? `${val} ₽` : 'Не указана цена';

const parseEvents = (data: Events): ParsedEvents => data.map(parse);

export default parseEvents;



// WEBPACK FOOTER //
// ./src/services/api/events/utils/parseEvents.ts